App.ReportAdapter = DS.LSAdapter.extend
  namespace: 'models'
